import { map, filter } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanDeactivate, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { enterTenantIndependentRoute, leaveTenantIndependentRoute } from '../../app.actions';
import { RootAppState } from '../../app.reducer';
import { selectCxbRootLevelRoles, selectCxbSelectedTenant } from '../../app.selectors';

@Injectable({
  providedIn: 'root',
})
export class TenantIndependentGuard implements CanActivate, CanDeactivate<unknown> {
  constructor(private readonly store: Store<RootAppState>) {}

  public canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.store.select(selectCxbRootLevelRoles).pipe(
      filter((rootLevelRoles) => !!rootLevelRoles),
      map(() => {
        this.store.dispatch(enterTenantIndependentRoute());
        return true;
      })
    );
  }

  public canDeactivate(
    component: unknown,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState?: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.store.select(selectCxbSelectedTenant).pipe(
      map((selectedTenant) => {
        if (selectedTenant) {
          this.store.dispatch(leaveTenantIndependentRoute({ tenant: selectedTenant }));
        }
        return true;
      })
    );
  }
}
